import log from 'salvo-lite/log'
import { getClosest } from '../helpers/general'
import 'dom-slider'
import axios from 'axios'

class Filter {
    constructor (theme, elem) {
        this.theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this._baseUrl = document.querySelector('[data-base-url]').getAttribute('data-base-url') + '/'
        this._clear = elem.getAttribute('data-filter') || false
        this._itemsWrapper = document.querySelector('[data-filter-items]')
        if (!this._clear) {
            const parent = getClosest(elem, 'ul')
            this._siblings = parent.querySelectorAll('input')
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const self = this
        this._elem.addEventListener('click', function () {
            if (self._clear) {
                self.clearFilters()
            } else {
                self.toggleSelectedSiblings()
            }
            self.ajaxUpdatePage()
        })
    }

    clearFilters () {
        const filters = document.querySelectorAll('[data-filter]')
        for (var i = 0; i < filters.length; i++) {
            filters[i].checked = false
        }
    }

    toggleSelectedSiblings () {
        for (var i = 0; i < this._siblings.length; i++) {
            if (this._siblings[i] !== this._elem) {
                this._siblings[i].checked = false
            }
        }
    }

    createAjaxUrl () {
        let ajaxUrl = this._baseUrl
        const selectedFilters = document.querySelectorAll('[data-filter]:checked')
        if (selectedFilters.length > 0) {
            if (ajaxUrl.includes('/blogs') && !this._clear) {
                ajaxUrl += 'tagged/'
            }
            if (selectedFilters.length > 0) {
                for (var i = 0; i < selectedFilters.length; i++) {
                    const value = selectedFilters[i].value
                    ajaxUrl = `${ajaxUrl}${value}+`
                }
                // remove trailing +
                ajaxUrl = ajaxUrl.slice(0, -1)
            }
        }
        return ajaxUrl
    }

    ajaxUpdatePage () {
        const ajaxUrl = this.createAjaxUrl()
        const self = this
        document.querySelector('[data-ajax-loader]').classList.remove('hide')
        axios.get(ajaxUrl).then(function (response) {
            // update page contents
            const filteredPage = document.createElement('div')
            filteredPage.innerHTML = response.data
            const filteredItems = filteredPage.querySelector('[data-filter-items]')
            if (filteredItems) {
                self._itemsWrapper.innerHTML = filteredItems.innerHTML
            }
            document.querySelector('[data-ajax-loader]').classList.add('hide')
            // // update page url
            // history.pushState(null, '', ajaxUrl)
        })
    }
}

export default Filter



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Filter.js